import { getDocs, collection, doc, updateDoc } from 'firebase/firestore';
import { db } from '../services/firebase';

// Valid category values
export const VALID_CATEGORIES = {
  FRANCHISE: 'Franchise',
  CORPORATE: 'Corporate'
};

/**
 * Standardizes all campaign categories in the database
 * This will ensure all category values are either "Franchise" or "Corporate" with proper capitalization
 */
export const standardizeCategories = async (): Promise<void> => {
  try {
    // Get all campaigns
    const campaignsSnapshot = await getDocs(collection(db, 'campaigns'));
    
    // Process each campaign
    const updatePromises = campaignsSnapshot.docs.map(async (campaignDoc) => {
      const data = campaignDoc.data();
      let originalCategory = data.category;
      
      // Skip if category is already null/undefined
      if (originalCategory === undefined || originalCategory === null) {
        return;
      }
      
      // Convert to string and lowercase for comparison
      const categoryLower = String(originalCategory).toLowerCase();
      
      // Determine the standardized category
      let standardizedCategory;
      if (categoryLower === 'franchise') {
        standardizedCategory = VALID_CATEGORIES.FRANCHISE;
      } else if (categoryLower === 'corporate') {
        standardizedCategory = VALID_CATEGORIES.CORPORATE;
      } else {
        // If it's neither, set to undefined
        standardizedCategory = undefined;
      }
      
      // Only update if the category has changed
      if (originalCategory !== standardizedCategory) {
        const campaignRef = doc(db, 'campaigns', campaignDoc.id);
        await updateDoc(campaignRef, { category: standardizedCategory });
        console.log(`Updated campaign ${campaignDoc.id} category from "${originalCategory}" to "${standardizedCategory}"`);
      }
    });
    
    // Wait for all updates to complete
    await Promise.all(updatePromises);
    console.log('All campaign categories have been standardized');
    
  } catch (error) {
    console.error('Error standardizing categories:', error);
    throw error;
  }
}; 